import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { CheckLg, ShieldCheck, Award } from "react-bootstrap-icons";
import "./AboutSection.css";

const AboutSection = () => {
  const aboutRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );

    if (aboutRef.current) observer.observe(aboutRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="about"
      className={`about-section ${animate ? "animate" : ""}`}
      ref={aboutRef}
    >
      <Container>
        <Row className="align-items-center g-5">
          
          {/* 🖼️ الصورة والكارت الطاير: بيدخلوا من اليمين (fade-in-right) */}
          <Col lg={6} className="fade-in-right delay-1 order-2 order-lg-1">
            <div className="about-image-wrapper">
              <div className="image-backdrop"></div>
              
              <div className="main-image-card shadow-lg">
                <img
                  src="/images/projects/transparent-pool-safety/transparent-pool-safety-1.webp"
                  alt="عن أعمال المسبح"
                  className="about-main-img"
                  loading="lazy"
                />
              </div>

              {/* الكارت الطاير المميز */}
              <div className="floating-stat-card shadow">
                <div className="stat-icon">
                  <Award size={28} />
                </div>
                <div className="stat-info">
                  <span className="stat-number">2018</span>
                  <span className="stat-label">خبرة وابتكار متواصل</span>
                </div>
              </div>
            </div>
          </Col>

          {/* 📝 الكلام والعناوين: بيدخلوا من الشمال جزء جزء بالتتابع (fade-in-left) */}
          <Col lg={6} className="order-1 order-lg-2">
            <div className="about-content text-start">
              
              <div className="splash-pill-badge mb-3 fade-in-left delay-1">
                <ShieldCheck className="me-1" /> عن اعمال المسبح التجارية
              </div>

              <h2 className="splash-title mb-4 fade-in-left delay-2">
                ابتكار وتصنيع <span className="highlight"> منتجات أمان المسابح والنوافير </span>
              </h2>

              <p className="splash-lead mb-4 fade-in-left delay-3">
                <strong> أعمال المسبح التجارية</strong>   متخصصين في تصنيع منتجات أمان المسابح والنوافير والشلالات الشفافة من مادة الأكريليك فايبر. تميزنا ينبع من كوننا مصنّعين ومبتكرين لا موزعين.
              </p>

              <div className="splash-features-grid">
                <div className="splash-feature-item fade-in-left delay-4">
                  <div className="feature-check"><CheckLg /></div>
                  <div className="feature-text">
                    <h4>ابتكار وتصنيع محلي</h4>
                    <p>جميع المنتجات من تصنيعنا بالكامل بتصاميم تجمع بين الأمان والأناقة.</p>
                  </div>
                </div>

                <div className="splash-feature-item fade-in-left delay-5">
                  <div className="feature-check"><CheckLg /></div>
                  <div className="feature-text">
                    <h4>براءات اختراع معتمدة</h4>
                    <p>نمتلك براءات اختراع خليجية تؤكد تميزنا وتضمن أعلى معايير السلامة.</p>
                  </div>
                </div>

                <div className="splash-feature-item fade-in-left delay-6">
                  <div className="feature-check"><CheckLg /></div>
                  <div className="feature-text">
                    <h4>إكسسوارات وشلالات متكاملة</h4>
                    <p>تشكيلة واسعة من الشلالات الشفافة وإكسسوارات النوافير الحديثة.</p>
                  </div>
                </div>

                <div className="splash-feature-item fade-in-left delay-7">
                  <div className="feature-check"><CheckLg /></div>
                  <div className="feature-text">
                    <h4>تغطية للمملكة والخليج</h4>
                    <p>نصل بخدماتنا لكافة مدن المملكة العربية السعودية ودول الخليج.</p>
                  </div>
                </div>
              </div>

            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;